import React from "react";

function Continue({ text, onClick, dictionary, loading, disabled }) {
  return (
    <div className="mt-5 mx-auto d-flex flex-column align-items-center justify-content-center">
      <button
        className="btn-large text-center"
        onClick={onClick}
        disabled={disabled}
      >
        {dictionary ? dictionary["WO_SAVE_-91866246"] : "SAVE"}
        {loading && (
          <>
            &nbsp;
            <i className="fa fa-spinner fa-spin" />
          </>
        )}
      </button>

      {/* <button className="save text-center mx-auto pt-3">
        Save and complete later
      </button> */}
    </div>
  );
}

export default Continue;
